
// import { Progress } from 'antd';
import React from 'react'

import "../css/Login.css";

export const HeaderAspirante = ({ btnCerrarSesion = false }) => {
    return (
        <>
            <nav className="header-login">
                <p className="lead no-select"> Examen de diagnóstico UTEsc </p>

                <div style={{position: "absolute", top: 40, right: 5}}>
                    {btnCerrarSesion}
                </div>

            </nav>

            {/* <div className='m-examen'>
                <Progress percent={ 50 }/>
            </div> */}

            {/* <Progre
                completed={2}
                bgColor="#2B8A7E"
                labelAlignment="outside"
                labelColor="#000000"
                maxCompleted={89}
                customLabel="hola owo"
            /> */}
        </>
    )
}

